import cookie from "react-cookies";

export const setSession = (id) => {
  return cookie.save("openaichat-sessionId", id, { path: "/" });
};

export const removeSession = () => {
  return cookie.remove("openaichat-sessionId", { path: "/" });
};

export const getSession = () =>{
  return cookie.load("openaichat-sessionId")

}